import { tokensUrl } from 'constants/urls';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';

import type { ITokenData } from 'typings/tokenData';
import { getQueryToken } from 'utils/helpers';
import axiosClient from 'utils/axios-client';

const getTokenData = async (
  tokenId?: string | null,
  date?: string
): Promise<ITokenData> => {
  if (typeof tokenId !== 'string' || tokenId.length === 0) {
    throw new Error('Token ID is not defined');
  }

  return (
    await axiosClient.get(
      `${tokensUrl}/${tokenId}`,
      date && date !== 'all' ? { params: { date } } : undefined
    )
  ).data;
};

export default function useGetTokenData(
  // eslint-disable-next-line default-param-last
  {
    id = getQueryToken(),
    enabled = false,
    keepPreviousData = false,
    refetchOnWindowFocus = false,
    ...options
  }: { id?: string | null } & Omit<
    UseQueryOptions<unknown, Error, ITokenData, QueryKey>,
    'queryKey' | 'queryFn'
  > = {},
  date: string = 'all'
) {
  return useQuery<unknown, Error, ITokenData>(
    [tokensUrl, id, date],
    () => getTokenData(id, date),
    {
      keepPreviousData,
      enabled,
      refetchOnWindowFocus,
      ...options,
    }
  );
}
